import { FunctionComponent, ReactNode } from "react";
import Icon from "@mdi/react";
import { mdiReload } from "@mdi/js";
import { Tooltip } from "@material-ui/core";
import moment from "moment";
import "../../../../styles/responsive_shrink.css";

interface ResponsiveListShellProps {
  title: string;
  count?: number;
  fetchedAt?: string | Date;
  onRefresh?: () => void;
  search?: ReactNode;
  actions?: ReactNode;
  filterToggle?: ReactNode;
  filterPanel?: ReactNode;
  children: ReactNode;
  locked?: boolean;
}

const ResponsiveListShell: FunctionComponent<ResponsiveListShellProps> = ({
  title,
  count,
  fetchedAt,
  onRefresh,
  search,
  actions,
  filterToggle,
  filterPanel,
  children,
  locked,
}) => {
  return (
    <div
      className={`mobile-shrink h-max px-3 pt-5 relative md:h-screen ${
        locked ? "overflow-hidden" : "overflow-y-auto overflow-x-hidden"
      }`}
    >
      <div className="flex flex-wrap justify-between items-end">
        <div>
          <h1 className="font-bold text-2xl text-gray-700 border-l-4 border-myPrimaryColor pl-2 flex items-center gap-2">
            {title}
            {count !== undefined && <span className="text-sm">({count})</span>}
            {onRefresh && (
              <span
                className="transform hover:scale-125 duration-300 cursor-pointer text-gray-400 hover:text-gray-800"
                onClick={onRefresh}
              >
                <Tooltip title="Refresh">
                  <div className="flex items-center">
                    <Icon path={mdiReload} className="w-4 h-4" />
                  </div>
                </Tooltip>
              </span>
            )}
          </h1>
          {(fetchedAt || onRefresh) && (
            <div className="flex gap-2">
              {fetchedAt && (
                <p className="text-xs text-gray-400">
                  Fetched at :{moment(fetchedAt).format("hh:mm:ss A")}
                </p>
              )}
            </div>
          )}
        </div>
        <div className="flex gap-2 items-center flex-wrap">
          {search && (
            <div className="search-grow w-full md:w-auto">{search}</div>
          )}
          {actions}
          {filterToggle}
        </div>
      </div>

      {filterPanel}

      {children}
    </div>
  );
};

export default ResponsiveListShell;
